// tslint:disable
export const es = {
  VerifyStatus: 'Verificar estado',
  MarkAsDispensed: 'Marcar como Dispensado',
  MarkAsSampled: 'Marcar como muestreado',
  UndoDispense: 'Deshacer Dispensar',
  UndoSample: 'Anular el muestreo',
  MarkAsDestroyed: 'Marcar como destruido',

  Alert: 'Aviso',
  ErrorCode: 'Código de error',
  WarningFromNmvs: 'Advertencia del Sistema Nacional de Verificación de Medicamentos para EPC',
  Reason: 'Razón',
  ContactAcknowledge: 'Póngase en contacto con un miembro de su equipo para confirmar este mensaje.',
  Acknowledge: 'Confirmar',

  CleanDateFormat: 'dd/mm/yyyy  h:MM:ss TT',
  ExpiryDateFormat: 'dd/mm/yyyy',
  ShortenedExpiryDateFormat: 'dd/mm/yyyy',

  ClearCompleted: 'Borrar lista',
  ManualEntry: 'Entrada manual',

  FileName: 'Nombre del fichero',
  Download: 'Descargar',
  ImvoPilotSetupInstructions: 'Instrucciones de configuración del piloto IMVO',
  ZebraDevicesSetupInstructions: 'Instrucciones de configuración de dispositivos Zebra',
  DataLogicGryphonGD4400: 'DataLogic Gryphon GD4400',
  DataLogicMagellan9800i: 'DataLogic Magellan 9800i',
  DataLogicMagellan3200VSI: 'DataLogic Magellan 3200 VSI',
  '232KeyConfiguration': '232Ajustes de configuración para el DataLogic Magellan 3200 VSI',

  ProductDetails: 'Detalles del producto',
  UserDetails: 'Detalles del usuario',
  ProductIdentification: 'Identificación del producto',
  SerialNumber: 'Número de serie',
  Expiry: 'Caducidad',
  LotNumber: 'Número de lote',
  Status: 'Estado',

  DeviceInfo: 'Info. del dispositivo',
  UserProfile: 'Perfil',
  Users: 'Usuarios',
  Settings: 'Configuración',
  Documentation: 'Documentación',
  Logout: 'Cerrar sesión',

  LoginErrorConnectivity: 'Debe estar conectado a Internet cuando inicie sesión por primera vez.',
  SessionTimeout: 'Tiempo de espera de la sesión',
  InvalidUsernamePassword: 'El nombre de usuario o la contraseña no es válido.',
  Unauthorized: 'No autorizado',
  TenantDoesNotExist: 'No existe un cliente con la identificación: ',
  Username: 'Nombre de usuario',
  Password: 'Contraseña',
  UsernameRequirement: 'El nombre del usuario debe contner entre 5 y 50 carácteres',
  RetypePassword: 'Confirmar contraseña',
  Login: 'Iniciar sesión',
  FirstName: 'Nombre(s)',
  LastName: 'Apellido(s)',
  ForgotPassword: 'Contraseña olvidada',
  ConfirmPasswordReset: 'Confirmar Restablecer Contraseña',
  ConfirmPasswordResetMessage: 'Seguro que quiere restablecer la contraseña para {{usuario}}',
  ResetPassword: 'Restablecer contraseña',
  PasswordResetSuccess: 'Se envió un mensaje al correo electrónico. Siga las instrucciones del mensaje para completar el restablecimiento de la contraseña.',
  PasswordResetError: 'Error: could not send the password reset email. Please try again in a few minutes.',
  PasswordResetOfflineError: 'Error: Debe estar conectado para restablecer la contraseña.',
  ForgotPasswordContactAdmin: 'Póngase en contacto con el administrador del Active Directory.',
  Email: 'Correo electrónico',
  OtherActions: 'Otras acciones',
  UserInfoWarning: 'Advertencia: No es posible modificar el nombre del usuario, el nombre y el apellido después de crear un usuario.',

  ScannedDateTime: 'Fecha/Hora del escaneo',
  NmvsResponseTime: 'Hora de la respuesta del NMVS',
  OptelResponseTime: 'Hora de la respuesta de OPTEL',
  TotalResponseTime: 'Tiempo total de la respuesta',
  Seconds: 'segundos',
  NotApplicable: 'N/A',
  
  Scan: 'Escanee',
  ScanOrTypeEpc: 'Escanee o escriba el Código Electrónico de Producto',
  EnterEpcManually: 'Try manually entering the electronic product code',
  EpcScannedAuditMessage: '{{username}} escaneó el Epc: {{epc}}, con la operación: {{operation}}',
  AlertAcknowledgedAuditMessage: 'Alerta reconocida por {{username}} para el clientTransactionId: {{clientTransactionId}}',
  Pending: 'Pendiente',
  NotFound: 'No se encontró',
  ProductCodeRequired: 'Se requiere un código de producto.',
  SerialNumberRequired: 'Se requiere un número de serie.',
  BatchIdentifierRequired: 'Se requiere un identificador de lote.',
  ExpiryDateRequired: 'Se requiere una fecha de caducidad.',
  UnprocessableEntity: 'Unprocessable Entity',

  DeviceId: 'Identificador del dispositivo',
  SystemInfo: 'Información sobre el sistema',
  Preferences: 'Preferencias',
  Credentials: 'Credenciales',
  Country: 'País',
  Language: 'Idioma',
  LocationIdentifier: 'Identificador de ubicación',
  Certificate: 'Certificado',
  CertificatePassword: 'Contraseña del certificado',
  Processing: 'Procesando...',
  Save: 'Guardar',
  CreateUser: 'Crear usuario',
  Submit: 'Enviar',
  ClientId: 'Introducir la identificación del cliente',
  FileNullError: 'Ha habido un error al leer el archivo.',
  InvalidFileError: 'Error: Los archivos tienen que acabar en .pfx o en p12',
  OfflineSettingsMessage: 'No puede actualizar la configuración cuando esté en modo sin conexión.',

  RegisterDevice: 'Register Device',
  UnregisterDevice: 'Unregister Device',
  UnregisterDeviceWarning: 'If you click this button, it will unregister this device from your location until the device is registered again.',
  
  Details: 'Detalles',
  User: 'Usuario',
  Barcode: 'Código de barras',
  Pin: 'PIN',
  RetypePin: 'Confirmar PIN',
  Role: 'Función',
  ChangePIN: 'Cambiar PIN',
  ChangePassword: 'Cambiar contraseña',
  PasswordMatchError: 'La contraseña no coincide',

  NoAvailableOperations: 'No hay operaciones disponibles para este artículo.',
  Verify: 'Verificar',
  TryVerifyAgain: 'Intente Verifcar nuevamente',
  Dispense: 'Dispensado',
  Sample: 'Muestrear',
  Destroy: 'Destruir',
  Reintroduce: 'Reintroducir',
  PleaseWait: 'Por favor, espere...',
  ProductCode: 'Código de producto',
  AvailableOperations: 'Operaciones disponibles',

  Cancel: 'Cancelar',
  AddUser: 'Añadir usuario',
  EditUser: 'Editar usuario',

  RoleTypeOptelAdmin: 'Admin. de Optel',
  RoleTypeOptelSupport: 'Soporte Optel',
  RoleTypeTenantAdmin: 'Admin. de ocupante',
  RoleTypeOperator: 'Operario',
  RoleTypeViewer: 'Visor',
  RoleTypeUnknown: 'Desconocido',

  Back: 'Atrás',
  ActivateUser: 'Activar usuario',
  DeactivateUser: 'Desactivar usuario',
  DeleteUser: 'Eliminar usuario',
  Delete: 'Eliminar',
  DeleteUserWarning: 'If you click this button, this user will be deleted permanently and it\s username won\'t be available anymore.',
  DeleteUserConfirmation: '¿Está seguro de que quiere eliminarlo {{username}} ?',
  Yes: 'Sí',
  No: 'No',
  ConfirmDeletion: 'Confirmar la eliminación',
  Error: 'Error',
  CommunicationError: 'Ocurrió un error de comunicación con el servidor. Haga clic para otro intento.',
  SaveError: 'Ocurrió un error durante la salvaguarda. Intente más tarde.',
  ClickTryAgain: 'Haga clic aquí para otro intento.',
  ClickErrorIconTryAgain: 'Click the error icon to try again.',

  LandingPageSloganPart1: 'AAC - Traceability Pilot for the Canadian Primary Aluminium Industry',
  LandingPageSloganPart2: '',
  FMDAcronym: 'FMD',
  EuropeanAcronym: 'EU',
  TermsAndConditions: 'Términos y condiciones',
  AboutOptel: 'Información sobre el Grupo OPTEL',
  AllRightsReserved: 'Reservados todos los derechos',
  OptelGroup: 'Grupo OPTEL',

  Online: 'Conectado',
  Offline: 'Sin conexión',
  AwaitingConnection: 'Esperando conexión...',
  SimulateOffline: 'Simulación sin conexión',
  UndoOfflineWarning: 'Atención: Revertir la operación no está disponible en modo sin conexión.',
  
  NothingToShow: 'Nada que mostrar',
  LoadingCerta: 'Cargando Certa. Si la acción toma más de 10 segundos, actualice la página.',

  OptelTermsOfUseTitle: 'Condiciones para la utilización del dispositivo OPTEL', 
  NmvsTermsOfUseTitle: 'Condiciones para la utilización del sistema NMVS',
  NmvsTermsOfUseWarning: 'Tome nota: Para aceptación del ocupante',
  Accept: 'Aceptar',
  Decline: 'Rechazar',
  Ignore: 'Ignorar',
  Dismiss: 'Despedir',
  ClickHere: 'haga clic aquí',
  
  MustAcceptTermsToLogin: 'Debe aceptar las condiciones de utilización para poder iniciar sesión.',
  MustBeOnlineToAcceptTermsToLogin: 'Debe tener conectividad a internet para aceptar las condiciones de utilización e iniciar sesión.',

  Austria: 'Austria',
  Belgium: 'Bélgica',
  Bulgaria: 'Bulgaria',
  Croatia: 'Croacia',
  Cyprus: 'Chipre',
  CzechRepublic: 'Republica checa',
  Denmark: 'Dinamarca',
  Estonia: 'Estonia',
  Finland: 'Finlandia',
  France: 'Francia',
  Germany: 'Alemania',
  Greece: 'Grecia',
  Hungary: 'Hungría',
  Iceland: 'Islandia',
  Ireland: 'Irlanda',
  Italy: 'Italia',
  Latvia: 'Letonia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituania',
  Luxembourg: 'Luxemburgo',
  Malta: 'Malta',
  Netherlands: 'Países Bajos',
  Norway: 'Noruega',
  Poland: 'Polonia',
  Portugal: 'Portugal',
  Romania: 'Rumania',
  Slovakia: 'Eslovaquia',
  Slovenia: 'Eslovenia',
  Spain: 'España',
  Sweden: 'Suecia',
  Switzerland: 'Suiza',
  UnitedKingdom: 'Reino Unido',

  UnableToParseEpc: 'No es posible analizar el código electrónico del producto.',
  UnderSizeError: 'dimensión insuficiente',
  OverSizeError: 'dimensión exedente',
  FixedSizeError: 'dimensión fija',
  NoSerializationData: 'No hay datos de serialización.',
  InvalidCheckDigit: 'Número de control inválido.',
  NoProductCodeForGtin: 'El GTIN no encontró un código del producto.',
  UrnFormatNotSupported: 'Formato URN no compatible',
  InvalidSymbologyIdentifier: 'El identificador de simbología no es válido.',
  NoSymbologyIdentifier: 'No hay identificador de simbología.',
  CouldNotFindTypeInfo: 'No se encontró TypeInfo.',
  NullTypeInfo: 'La TypeInfo no puede ser nula.',
  DigitsOnly: 'Cifra únicamente, el AI contiene caracteres que no son cifras',
  CannotSerializeUnknownAi: 'No es posible serializar el AI con un type desconocido.',
  CheckValueNotChar: 'El carácter debe ser una cifra.',
  CheckValueTooBig: 'CheckValue no puede ser mayor que 9.',
  InvalidFormat: 'Formato no válido.',
  CapsLockDetected: 'Se bloquó el escaneo debido a que la tecla BLOQUEAR MAY. está activa.',
  CapsLockSolution: 'Presione la tecla BLOQUER MAY. en su teclado y escanee el código nuevamente.',
  ScanAttemptDetected: 'Se detectó un escáner pero no pudo ser analizado.',
  ScanAttemptSolution: 'Asegurése que su escáner esta configurado correctamente tal como lo requiere OPTEL para trabajar con la aplicación Certa. ',
  Active: 'Activo',
  FullName: 'Nombre completo',
  OnlineAssistance: 'Asistencia Certa en línea',
  UnknownErrorOccurred: 'Un error desconocido ocurrió en {{function}}.',
  SeparatorMissing: 'Carácter de separación GS faltante',
  SeparatorSolution: 'Reconfigure su escáner y convierta el carácter GS en un espacio o en ^.',
  ScanCount: 'Conteo del escáner',
  ProductName: 'Nombre del producto',
  ConfirmUnregisterDeviceMessage: '¿Está seguro de querer desinscribir el dispositivo? ',
  Confirm: 'Confirmar'
};



// WEBPACK FOOTER //
// ./src/translations/translations.es.ts